/**
 * 在 React 里「读」Zustand：useStore(selector)
 *
 * 【取单个字段】selector 返回原始值或稳定引用 → 仅在该值变化时重渲染
 *   例：useChatMuseStore((s) => s.seessionId)
 *
 * 【取多个字段为对象】默认每次 {} 都是新引用 → 会死循环；用 useShallow 包一层做浅比较
 *
 * 【只拿方法、不订阅数据】可用 useChatReelStore((s) => s.setSeessionId) 拆成多个 hook；
 *   或在非组件里：useChatMuseStore.getState().setSeessionId(...)
 */
import { useShallow } from 'zustand/react/shallow';
import { useChatReelStore } from '../stores/chat-reel';

/** 同时取出 setSeessionId / setSelectBrand；必须用 useShallow，见文件头注释 */
export const useChatReelActions = () =>
  useChatReelStore(
    useShallow((s) => ({
      setSeessionId: s.setSeessionId,
      setSelectBrand: s.setSelectBrand,
      setReelGlobaldisabled: s.setReelGlobaldisabled,
      setEntityCount: s.setEntityCount,
      setEntityModalOpen: s.setEntityModalOpen,
      setEntityFormModalOpen: s.setEntityFormModalOpen,
      resetPageStatus: s.resetPageStatus,
      setChatInputFileList: s.setChatInputFileList,
      setChatInputVideoFileList: s.setChatInputVideoFileList,
      setChatInputAudioFileList: s.setChatInputAudioFileList,
      setModelList: s.setModelList,
      setReelModel: s.setReelModel,
      setYoutubeUrl: s.setYoutubeUrl,
      setGenerateVideoData: s.setGenerateVideoData,
      requestChatInputDraftReset: s.requestChatInputDraftReset,
      setSkillObj: s.setSkillObj,
      setStoreSelectionDraft: s.setStoreSelectionDraft,
      setSelectionModeInfo: s.setSelectionModeInfo,
      setAgentStep: s.setAgentStep,
      setHasAssistantMessage: s.setHasAssistantMessage,
      setHasHistoryMessages: s.setHasHistoryMessages,
      setHistoryMessagesLoaded: s.setHistoryMessagesLoaded,
      setCanvasReady: s.setCanvasReady,
      setGlobalConfig: s.setGlobalConfig,
      setCanvasId: s.setCanvasId,
      markHistorySessionChanged: s.markHistorySessionChanged,
      resetHistorySessionChanged: s.resetHistorySessionChanged,
    })),
  );
